import { grey } from '@material-ui/core/colors';

export default (theme) => ({
  icon: { margin: theme.spacing(2) },
  textField: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  section: { marginBottom: '1em' },
  dateIcon: { color: 'rgb(158, 158, 158)' },
  toggleText: { fontSize: '14px' },
  info: {
    fontSize: '18px',
    marginLeft: 5,
  },
  list: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  listItem: { padding: 0 },
  listItemSummary: { padding: 0 },
  advancedExpansionPanel: {
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
  },
  dateButton: {
    fontSize: '0.7125rem',
    textTransform: 'uppercase',
  },
  sectionHeaderText: {
    marginTop: 0,
    marginBottom: 0,
  },
  sectionHeaderContainer: {
    display: 'flex',
    lineHeight: 1,
    alignItems: 'center',
    marginTop: 10,
    marginBottom: 10,
  },
  flex: { flex: 1 },
  input: { background: grey[50] },
  selectFormControl: {
    marginBottom: '1rem',
    width: '100%',
  },
  buttonGroup: { marginBottom: '1em' },
});
